var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row row-equal"},[_c('div',{staticClass:"flex md12"},[_c('va-card',{attrs:{"title":"Impayés"}},[_vm._v(" - ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }